import { ApiRequest } from './requests';
import {
  DeviceCodeResponse,
  DeviceCodeStatusRequest,
  DeviceCodeStatusResponse,
  DeviceLoginRequest,
  DeviceLoginResponse,
} from '../models/authorization';
import { CueResponse } from '../models/common';

export function getDeviceCode(): ApiRequest<void, DeviceCodeResponse> {
  return {
    url: '/api/unit-client/device-code',
    method: 'get',
  };
}

export function deviceCodeStatus(
  deviceCode: string,
  fn: any
): ApiRequest<DeviceCodeStatusRequest, DeviceCodeStatusResponse> {
  return {
    url: '/api/unit-client/device-code-status',
    payload: {
      deviceCode: deviceCode,
    },
    method: 'post',
    catchFn: fn,
  };
}

export function deviceLogin(
  clientId: string,
  clientSecret: string
): ApiRequest<DeviceLoginRequest, DeviceLoginResponse> {
  return {
    url: '/api/account/device-login',
    method: 'post',
    payload: {
      clientId: clientId,
      clientSecret: clientSecret,
    },
  };
}

export function deviceRefresh(
  refreshToken: string
): ApiRequest<{ refreshToken: string }, CueResponse<{ token: string; refreshToken: string }>> {
  return {
    url: '/api/account/device-refresh',
    method: 'post',
    payload: {
      refreshToken: refreshToken,
    },
  };
}
